import React, {Component} from 'react';
import {withRouter} from 'react-router-dom';
import translationsRoutes from './translations_routes';

const routes = Object.values(translationsRoutes);

/**
 * Scroll restoration for React Router.
 * It will scroll the window up on every navigation (except for some specific path).
 *
 * @link https://github.com/ReactTraining/react-router/blob/master/packages/react-router-dom/docs/guides/scroll-restoration.md
 * @link https://reacttraining.com/react-router/web/guides/scroll-restoration
 */
class ScrollToTop extends Component {
    componentDidUpdate(prevProps, prevState) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            const routesWithOutScroll = [
                routes[0].schools[0],
                routes[0].schools[1],
                routes[0].events[0],
                routes[0].events[1],
                routes[0].news[0],
                routes[0].news[1],
            ];

            if (routesWithOutScroll.indexOf(this.props.location.pathname) === -1) {
                window.scrollTo(0, 0);
            }
        }
    }

    render() {
        return this.props.children;
    }
}

export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/app/router/ScrollToTop.js